<div class="content-message-container">
    <div>
        <div>
            <div class="content-message {{ notificationInfo.type }}">
                <span class="notification-alignment {{ notificationInfo.iconColor }}"><vn-icon size="16" [name]="notificationInfo.icon" /></span>
                @if (showCloseButton) {
                    <span class="button-alignment" (click)="onCloseClick()"><vn-icon name="theme-ex" size="12" /></span>
                }
                <div class="page-matrix">
                    <div>
                        <div class="pc-text pc-component">
                            @if (notificationHeaderTitle) {
                                <span class="betslip-notification-title"> {{ notificationHeaderTitle }} </span>
                            }
                            @if (message) {
                                <section class="pc-richtext" [innerHTML]="message"></section>
                            }
                            <ng-content select="[message]" class="pc-richtext" />
                            @if (linkValues) {
                                <div class="link">
                                    <a [href]="linkValues.href" [attr.target]="linkValues.target" (click)="onLinkClick()">{{ linkValues.link }}</a>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
